var $b4fa8198ca731e89$exports = {};
$b4fa8198ca731e89$exports = {
    "alert": `Varning`,
    "dismiss": `Avvisa`
};


export {$b4fa8198ca731e89$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
